<div class="row m-0 h-100">
  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 LoginBg setPadding ">
    <div class="row m-0 h-100 login">
      <div class="row_tab ">
        <app-header></app-header>
      </div>
      <div class="row_tab align-self-center blue_rectangle">

          <div class="col-12 align-self-center">
            <h3 class="mb-4">CREATE ACCOUNT</h3>
          </div>
          <form [formGroup]='email'>
            <div class="row m-0">
              <div class="col-12 p-0">
                <mat-form-field class="col-12">
                  <input matInput placeholder="Email Address" required name="Email" formControlName="Email" maxlength="60">
                  <mat-error *ngIf="email.controls.Email.invalid">Enter a valid Email</mat-error>
                </mat-form-field>
              </div>
              <div class="buttonpadding">
                <button class="btn_padding" mat-raised-button color="primaryCus"
                (click)='SetCookie()'>CREATE</button>

              </div>
            </div>
          </form>
          <div class="register">
            <p>Already a User in StandardC ? </p>
            <p class="pointer" (click)='goToLogin()'> Login</p>
          </div>

      </div>

      <div class="col-12">
        <app-footer></app-footer>

      </div>

    </div>

  </div>
  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 fontwhite p-50">
        <!-- <h2>
          Hi, Welcome
        </h2>
        <p class="paraFont">
          An end-to-end, transparent transactional platform where origin, quality, safety and traceability are critical
          to the public, regulators and financial institutions.
        </p> -->

      </div>
    </div>
    <div class="copyright pos-abs text-center">
      <p class="mb-4 fontwhite">
        <!-- © {{year}} StandardC. All Rights Reserved      </p> -->
    </div>
    <div  class="yellow_square"></div>

  </div>
</div>
<!-- <div class="container">
    <div class="loginContainer">

    </div>
    <div class="welcomeContainer">

    </div>
</div> -->
